<template>
  <a-card :bordered="false" title="配送服务" :headStyle="{ fontSize: '18px' }">
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="运费模板">
        <div>
          <div>
            <a-button type="primary" @click="AddCarriageTemplate">添加运费模板</a-button>
          </div>
          <custom-page-table ref="table" rowKey="id" :columns="columns" :requestPromise="loadPromise">
            <span slot="action" slot-scope="rowItem">
              <a style="margin-right: 20px;" @click="edit(rowItem.record.id)">编辑</a>
              <a-popconfirm title="是否删除此模板?" @confirm="deleted(rowItem.record.id)">
                <a>删除</a>
              </a-popconfirm>
            </span>
          </custom-page-table>
        </div>
      </a-tab-pane>
      <!-- <a-tab-pane key="2" tab="同城配送">暂未开发</a-tab-pane>
      <a-tab-pane key="3" tab="上门自提">暂未开发</a-tab-pane> -->
    </a-tabs>
  </a-card>
</template>

<script>
export default {
  name: 'ConsolidationServices',
  data() {
    return {
      loadPromise: params => this.getRecordData(params),
      columns: [
        {
          title: '模板名称',
          dataIndex: 'templateName'
        },
        {
          title: '模板类型',
          dataIndex: 'templateTypeText'
        },
        {
          title: '计费方式',
          dataIndex: 'feeTypeText'
        },
        {
          title: '最后修改时间',
          dataIndex: 'lastUpdateTimeStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      isSuccess: 0,
      cloudMerchantId: this.$store.getters.userInfo.merchantId,
      cloudPlatformId: this.getPlatformConfig().platformId
      // merchantId:this.$store.getters.userInfo.merchantId,
      // platformId:this.getPlatformConfig().platformId
    }
  },
  mounted() {
  },
  methods: {
    edit(id) {
      this.$router.push({
        name: 'AddCarriageTemplate',
        query: {
          id: id,
          cloudMerchantId: this.cloudMerchantId,
          cloudPlatformId: this.cloudPlatformId
        }
      })
    },
    deleted(id) {
      this.getHttpServices()
        .getCloudProService()
        .post('base/express/fee/delete',
          {
            templateId: id,
            merchantId: this.cloudMerchantId,
            platformId: this.cloudPlatformId
          })
        .then(res => {
          this.$refs.table.refresh(true)
          this.$message.success('成功删除')
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    AddCarriageTemplate() {
      this.$router.push({
        name: 'AddCarriageTemplate',
        query: {
          cloudMerchantId: this.cloudMerchantId,
          cloudPlatformId: this.cloudPlatformId
        }
      })
    },
    getRecordData(params) {
      let arr = []
      arr.merchantId = this.cloudMerchantId
      arr.platformId = this.cloudPlatformId
      arr.pageNum = params.limitDto.pageNum
      arr.pageSize = params.limitDto.pageSize
      this.getLogUtils().logWithTag('getRecordData---arr', arr)
      return this.getHttpServices()
        .getCloudProService()
        .get('base/express/fee/list', arr)
    }
  }
}
</script>
<style scoped>
</style>